module.exports = __webpack_public_path__ + "img/slider-3-mobile.0fa0a27f.png";